import React from 'react'
import Message from '@paypalcorp/worldready-react'

function ErrorPage404() {
  return (
    <div>
      <div className="vx_globalNav-main globalNav-main js_globalNavView">
        <div className="vx_globalNav-container">
          <a
            id="header-ppLogo"
            name="header-logo"
            className="vx_globalNav-brand_desktop header__logo"
            pa-marked="1"
          >
            <div className="ppvx_text--md header__logo-text">DropZone</div>
            <span className="vx_a11yText">DropZone</span>
          </a>
        </div>
      </div>
      <div className="error_content flexCenter" id="contents" role="main">
        <div className="error_content-wrapper flexCenter">
          <h2 className="ppvx_text--lg"><Message id="error.404.page" /></h2>
          <p className="ppvx_text--md">
            <Message id="error.404.page.text" />
          </p>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage404
